// API Configuration
// This file manages API endpoints for different environments

// Base URL for API services
// In development: uses direct HTTP connection to internal service
// In production: uses relative path that will be proxied by Apache/Nginx
export const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

// API Endpoints
export const ENDPOINTS = {
  // Estaciones endpoint
  estaciones: `${API_BASE_URL}/estaciones`,
};
